import { createContext } from "react";

/**
 * 무빈소 B 퍼널의 화면 chrome(footer / 이탈 방지)을 하위 화면에서 제어하는 컨텍스트.
 * - setHideFooter(true): RenewalFooter 숨김 (전환화면 등)
 * - setPreventLeave(false): 이탈 방지(beforeunload/routeChangeStart) 비활성화 (가이드 화면 등)
 * 값은 MatchRequestContainer가 주입하며, 없으면(비무빈소) null.
 */
export interface MubinsoScreenChrome {
  setHideFooter: (hide: boolean) => void;
  setPreventLeave: (prevent: boolean) => void;
}

export const MubinsoScreenChromeContext = createContext<MubinsoScreenChrome | null>(null);
